import styled from "styled-components";

import { FONTS } from "../../../../utils/constants";

export const ReadOnlyValue = styled.span`
  font-family: ${FONTS.serif};
  font-size: var(--text-md);
  font-weight: 600;
  color: var(--color-text-default);
`;
